import React from 'react';
// @ts-ignore
import { Banner } from '@pwc/appkit-react/lib/Banner';
import { useIdleProcessValues } from '../queries/idleProcess';


const MaintenanceBannerComponent = () => {
  const { data: idleProcessValues } = useIdleProcessValues();

  const bannerMsg = idleProcessValues.lockFlag === 'Y' ? ( <Banner status="warning" content={'Client is locked'} /> ) : null;
  return idleProcessValues.maintenanceFlag === 'Y' ? ( <Banner status="warning" content={'Client is in maintenance mode'} /> )
    : bannerMsg;
};

export default MaintenanceBannerComponent;
